<!-- Member Onboarding Banner - Dark card with blue accents -->
<div *ngIf="isVisible()" class="member-onboarding-banner mb-3">
  <div class="d-flex justify-content-between align-items-start">
    <div class="flex-grow-1">
      <!-- Welcome Message -->
      <div class="d-flex align-items-center mb-2">
        <div class="icon-wrapper me-3">
          <i class="bi bi-rocket-takeoff fs-4"></i>
        </div>
        <div>
          <h5 class="mb-0">Welcome to {{ organizationName() }}!</h5>
          <p class="subtitle mb-0">Complete your profile to start operations.</p>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="progress-section mb-3">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="progress-label">Progress</span>
          <span class="progress-value">{{ progress()?.percentComplete || 0 }}%</span>
        </div>
        <div class="progress-track">
          <div
            class="progress-fill"
            role="progressbar"
            [style.width.%]="progress()?.percentComplete || 0"
            [attr.aria-valuenow]="progress()?.percentComplete || 0"
            aria-valuemin="0"
            aria-valuemax="100">
          </div>
        </div>
      </div>

      <!-- Remaining Items -->
      <div *ngIf="remainingItems().length > 0" class="next-steps mb-3">
        <p class="steps-label mb-2">Next Steps:</p>
        <ul class="steps-list mb-0">
          <li *ngFor="let item of remainingItems()">
            <i class="bi bi-circle me-2"></i>
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- Complete Onboarding Button -->
      <button
        type="button"
        class="btn btn-outline-light btn-sm action-btn"
        (click)="completeOnboarding()">
        <i class="bi bi-check-circle me-1"></i>
        Complete Onboarding
      </button>
    </div>

    <!-- Dismiss Button -->
    <button
      type="button"
      class="dismiss-btn"
      aria-label="Dismiss"
      (click)="dismiss()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
